import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [],total:0,error: "", message: "" }


export const pendingEarningTransactionAction = createAsyncThunk(
    'pending-earning-transaction',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/admins/api/pending-transaction/${data.page}/${data.limit}/${data.startDate}/${data.endDate}/${data.isPending}?appId=${data.app}&userId=${data?.userId}&partner=${data?.partner}`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const pendingEarningTransactionSlice = createSlice({
    name: 'pending-earning-transaction',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(pendingEarningTransactionAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(pendingEarningTransactionAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
                state.total = action?.payload?.total
            })
            builder.addCase(pendingEarningTransactionAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
                state.total = action?.payload?.total

            })
        },

})



export const pendingEarningTransactionReducer = pendingEarningTransactionSlice.reducer